/* eslint-disable indent */
import React, { useState } from "react";
import MasterSearch from "../../components/Master/MasterSearch";
import { Row } from "antd";
import { reportPaths } from "../../config/reportPaths";
import MasterCard from "../../components/Master/MasterCard/MasterCard";
import useCustomNavigate from "../../components/customNavigationHook";

const Reports = () => {
  const navigate = useCustomNavigate();
  const [inputSearchValue, setInputSearchValue] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [masterSearchTitle, setMasterSearchTitle] = useState("Reports");
  const filterArray = (dataSource, currValue) =>
    dataSource?.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(currValue.toLowerCase())
      )
    );
  const setVisibleMasterList = () => {
    window.history.back();
  };

  const onClickHandler = (route) => {
    // Clear DRS Report date range when navigating to DRS Report
    if (route === "/delivery-mis-report") {
      try {
        localStorage.removeItem("drsReportDateRange");
      } catch (error) {
        console.error("Error clearing drsReportDateRange from localStorage:", error);
      }
    }
    navigate(route);
  };

  const searchSetting = (e) => {
    const currValue = e.target.value;
    setInputSearchValue(currValue);

    const filteredData =
      inputSearchValue.length > 0 || inputSearchValue.length == 0
        ? filterArray(reportPaths, currValue)
        : filterArray(reportPaths, currValue);
    setDataSource(filteredData);
  };
  return (
    <div className="master-container">
      <Row gutter={30}>
        <MasterSearch
          title={reportPaths.length > 0 ? reportPaths[0].parentHeading : ""}
          search={searchSetting}
          setVisibleMasterList={setVisibleMasterList}
          setMasterSearchTitle={setMasterSearchTitle}
          goBack={"master"}
          MasterSearch={false}
        />
        {inputSearchValue.length == 0
          ? reportPaths.map((e) => {
              return (
                <MasterCard
                  id={e.id}
                  key={e.id}
                  title={e.title}
                  imgSrc={e.imgSrc}
                  route={e.route}
                  onClickHandler={onClickHandler}
                  searchTitle={masterSearchTitle}
                  disable={e.disable}
                />
              );
            })
          : dataSource.map((e) => {
              return (
                <MasterCard
                  id={e.id}
                  key={e.id}
                  title={e.title}
                  imgSrc={e.imgSrc}
                  route={e.route}
                  onClickHandler={onClickHandler}
                  searchTitle={masterSearchTitle}
                  disable={e.disable}
                />
              );
            })}
      </Row>
    </div>
  );
};

export default Reports;
